module.exports = __webpack_public_path__ + "img/glogo218.fca94cae.png";